const types = {
	userUpdateRejected: 'user_update_rejected',
	casesQuarterlyNeed: 'cases_quarterly_need'
};

const locale = {
	[types.userUpdateRejected]: 'оновлення даних користувача відхилено',
	[types.casesQuarterlyNeed]: 'Замовлення касет на квартал'
};

module.exports = {
	enum: types,
	locale: locale
};
